import { BrowserModule } from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule} from '@angular/core';
import { MainRoutingModule } from './view/main.router';
import { AppComponent } from './app.component';
import { NeqErrorHandler } from '@sharedcommon/error.handler';
import { RedirectGuard } from '@sharedcommon/guards/redirect.guard';
import { EnsureUserAuthGuard } from '@usercommon/guards/auth.guards';
import { ReactiveFormsModule } from '@angular/forms';
import { RightsGuard } from '@sharedcommon/guards/rights.guard';
import { LoggerService, UserLoggerService } from '@sharedcommon/services/logger.service';
import { NeqTranslateLoader } from '@sharedcommon/translate/translate.loader';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateCanActivate } from '@sharedcommon/guards/translate.guard';
import { UserService } from '@sharedcommon/services/user.service';
import { RawMaterialGuard } from '@usercommon/guards/rawmaterial.guard';
import { ResultSettingsService } from '@usercommon/service/result-settings.service';
import { HasEntityGuard } from '@usercommon/guards/has-entity.guards';
import {ExportService} from '@usercommon/service/export.service';
import { CookieService } from 'ngx-cookie-service';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {RawMaterialMatricesResolver} from '@usercommon/resolvers/rawmaterial-matrices-resolver';
import {NeqModule} from '@root/user/src/app/view/neq/neq.module';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, msalInterceptorConfig } from './config/auth-config';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { StoredUserGuard } from '@usercommon/guards/store-user.guard';
import { OperatingModeGuard } from '@usercommon/guards/operating-mode.guard';

import { ImportSemiAutoService } from '@usercommon/service/import-semiauto.service';
import { ImportSemiAutoStore } from '@usercommon/stores/import-semiauto.store';
import {ProgressBarModule} from 'primeng/progressbar';
import { SampleAdvancedSearchService } from '@usercommon/service/sample-advanced-search.service';
import { RawmaterialOrSampleService } from '@usercommon/service/rawmaterial-or-sample.service';
import { RawMaterialsMultiEditService } from '@usercommon/service/rawmaterials-multi-edit.service';
import { SampleService } from '@usercommon/service/sample.service';
import { DmsAndSampleService } from '@usercommon/service/dms-and-sample.service';
import { AuthenticationService } from '@usercommon/service/authentication.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new NeqTranslateLoader(http);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    MainRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [ HttpClient ]
      }
    }),
    MatProgressBarModule,
    NeqModule,
    MsalModule.forRoot(
      new PublicClientApplication(msalConfig),  // MSAL Configuration
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['openid', 'profile'],
        },
        loginFailedRoute: "/"
      }, // MSAL Guard Configuration
      msalInterceptorConfig
    ), ProgressBarModule
  ],
  exports: [

  ],
  providers: [
    CookieService, AuthenticationService,
    ResultSettingsService,
    RawMaterialsMultiEditService,
    ExportService,
    { provide: ErrorHandler, useClass: NeqErrorHandler },
    { provide: LoggerService, useClass: UserLoggerService },
    StoredUserGuard,
    RedirectGuard, EnsureUserAuthGuard, TranslateCanActivate, RightsGuard, RawMaterialGuard, HasEntityGuard, OperatingModeGuard,
    SampleAdvancedSearchService,
    RawMaterialMatricesResolver, RawmaterialOrSampleService, SampleService,
    DmsAndSampleService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalGuard,
    MsalBroadcastService,
    MsalService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    ImportSemiAutoService, ImportSemiAutoStore
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [ AppComponent, MsalRedirectComponent ]
})
export class AppModule {
  constructor(userService: UserService) {
    userService.manageLang();
  }
}
